module.exports = "/_next/static/images/3b81625806e8dc0ad403111b8a597713.png";